var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'phone-input',
    'transition-input',
    _vm.disabled && 'disabled',
    _vm.error && 'error',
  ]},[_c('MazPhoneNumberInput',{staticClass:"text-input",attrs:{"id":_vm.id,"noValidation":true,"noExample":true,"fetchCountry":_vm.fetchCountry,"default-country-code":_vm.countryCode,"translations":{
      countrySelectorLabel: _vm.areaLabel,
      phoneNumberLabel: _vm.label,
    },"disabled":_vm.disabled},on:{"update":_vm.onUpdate,"focus":_vm.onFocus,"blur":_vm.onBlur},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}}),_c('InputError',{attrs:{"error":_vm.error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }